import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { supabase } from "../utils/supabase/client";


export default function Logout() {
  const navigate = useNavigate();

  useEffect(()=>{
    

    // Clear localStorage immediately
    localStorage.clear();
    sessionStorage.clear();

    // Show success message
    toast.success("Logged out successfully");

    // Navigate immediately - don't wait for async operations
    navigate("/login", { replace: true });

    // Clear Supabase session in background (don't await)
    supabase.auth.signOut().catch((err) => {
    });
  },[navigate])
  

  return (
    <>

    </>
  );
}
